import { Reducer } from "redux";

import { get404InitialData } from "../utils";
import { BenefitPlanStateMasterActionDispatchTypes } from "../constants/Master";
import { BenefitPlanStatesMasterResponse } from "../models/Api/Master";
import { BenefitPlanStateDispatchTypes } from "../models/DispatchTypes/Patient";

export const initialState: BenefitPlanStatesMasterResponse = {
  loading: false,
  response: [],
};

const BenefitPlanStateReducer: Reducer<
  BenefitPlanStatesMasterResponse,
  BenefitPlanStateDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case BenefitPlanStateMasterActionDispatchTypes.BENEFIT_PLAN_STATE_MASTER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case BenefitPlanStateMasterActionDispatchTypes.BENEFIT_PLAN_STATE_MASTER_SUCCESS: {
      return {
        ...state,
        response: get404InitialData(action.response, []),
        loading: false,
      };
    }
    case BenefitPlanStateMasterActionDispatchTypes.BENEFIT_PLAN_STATE_MASTER_ERROR: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default BenefitPlanStateReducer;
